const setCurrentUserConsults = (state, payload) => {
  state.currentUserConsults = payload;
}

export default {
  setCurrentUserConsults
}
